import { useState } from "react";
import { marqueeLines } from "@/data/portfolio";

function Ribbon({ words, reverse, muted, paused }) {
  const items = [...words, ...words, ...words];
  return (
    <div
      className="marquee-track flex w-max items-center gap-8 whitespace-nowrap will-change-transform"
      style={{
        animationDuration: "60s",
        animationDirection: reverse ? "reverse" : "normal",
        animationPlayState: paused ? "paused" : "running",
      }}
    >
      {items.map((w, i) => (
        <span key={i} className="flex items-center gap-8">
          <span
            className={`font-display text-4xl font-extrabold uppercase tracking-tight transition-colors sm:text-6xl ${
              muted
                ? "text-transparent [-webkit-text-stroke:1px_hsl(var(--border))]"
                : paused
                ? "text-foreground"
                : "text-foreground/80"
            }`}
          >
            {w}
          </span>
          <span className="h-2 w-2 shrink-0 rotate-45 bg-primary/70" />
        </span>
      ))}
    </div>
  );
}

// Editorial ribbon — two layers moving in opposite directions. Slows + sharpens on hover.
export function Marquee() {
  const [hover, setHover] = useState(false);
  return (
    <div
      aria-hidden="true"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="relative select-none overflow-hidden border-y border-border/50 py-8"
    >
      <div className="flex flex-col gap-2">
        <Ribbon words={marqueeLines.top} paused={hover} />
        <Ribbon words={marqueeLines.bottom} reverse muted paused={hover} />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-28 bg-gradient-to-r from-background to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-28 bg-gradient-to-l from-background to-transparent" />
    </div>
  );
}
